var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56 56",
    width: "3.5rem",
    height: "3.5rem",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1c4ec1;\n      }\n\n      .cls-2 {\n        fill: #1c4ec1;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: url(#checkRadialGradiention);\n      }\n\n      .cls-5 {\n        fill: none;\n        stroke: #1c4ec1;\n        stroke-width: 2px;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "checkRadialGradiention",
    cx: 38.04,
    cy: 33.63,
    fx: 38.04,
    fy: 33.63,
    r: 3.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#e6e6e6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36 -31) scale(2.05)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.77,38.96h-9.77v-3.49h-2v3.49h-9.77v-19.03l10.77-3.1,10.77,3.1v19.03ZM30.73,37.23h6.32v-16l-9.05-2.6-9.05,2.6v16h6.32v-3.49h5.46v3.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.07,
    y: 22.42,
    width: 1.73,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.59,
    y: 22.42,
    width: 1.73,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.11,
    y: 22.42,
    width: 1.73,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.63,
    y: 22.42,
    width: 1.73,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.07,
    y: 26.17,
    width: 1.73,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.59,
    y: 26.17,
    width: 1.73,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.11,
    y: 26.17,
    width: 1.73,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.63,
    y: 26.17,
    width: 1.73,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.07,
    y: 29.92,
    width: 1.73,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.59,
    y: 29.92,
    width: 1.73,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.11,
    y: 29.92,
    width: 1.73,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.63,
    y: 29.92,
    width: 1.73,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.07,
    y: 33.66,
    width: 1.73,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.63,
    y: 33.66,
    width: 1.73,
    height: 1.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.04,
    cy: 34.02,
    r: 6.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "35.09 32.55 34.42 33.51 37.32 36.21 41.66 31.87 40.88 31.04 37.44 34.18 35.09 32.55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCompliance);
export default __webpack_public_path__ + "static/media/ico_compliance.33abbe54ec58d85fe5458a2f6a60a420.svg";
export { ForwardRef as ReactComponent };